import { breadcrumb } from './breadcrumb';

export const db = {
  breadcrumb,

  database: {
    status: {
      fresh: 'Creature',
      processing: 'Import',
      error: 'Error',
      ready: 'Ready',
      removed: 'Removed',
      sorting: 'Sorting'
    },

    field: {
      recipients: 'Recipients',
      group: 'Groups'
    },

    table: {
      action: {
        move: 'Move',
        add_contact: 'Add contact'
      }
    },

    button: {
      create: 'Create database'
    },

    form: {
      without_group: 'No group'
    },

    modal: {
      remove: {
        content: 'Are you sure you want to delete the database {name}?'
      }
    }
  },

  group: {
    field: {
      databases_count: 'Database'
    },

    modal: {
      remove: {
        content: 'Are you sure you want to delete the group {name}?'
      }
    },

    button: {
      create: 'Create a group'
    }
  },

  recipient: {
    required_format: 'Make sure the number is in international format.',
    birthdate_format: 'DD.MM',
    not_allow_select: 'Unable to select database, no recipients',

    field: {
      number: 'Phone',
      email: 'Email Address',
      first_name: 'First name',
      last_name: 'Last name',
      age: 'Age',
      sex: 'Sex',
      country: 'Country',
      city: 'City',
      birthdate: 'Birthday',
      custom1: 'Field #1',
      custom2: 'Field #2',
      custom3: 'Field #3',
      custom4: 'Field #4',
      custom5: 'Field #5'
    },

    tags: {
      number: 'Phone',
      email: 'Email Address',
      first_name: 'First name',
      last_name: 'Last name',
      age: 'Age',
      country: 'Country',
      city: 'City',
      birthdate: 'Birthday',
      custom1: 'Field #1',
      custom2: 'Field #2',
      custom3: 'Field #3',
      custom4: 'Field #4',
      custom5: 'Field #5'
    },

    button: {
      create: 'Create contact',
      import: 'Import',
      export: 'Export',
      sort: 'Sort'
    },

    modal: {
      remove: {
        content: 'Are you sure you want to delete the recipient with the number {number}?'
      },

      import: {
        title: 'Import Database',
        content: 'Import file (csv, xls).',
        required_format: 'Make sure the numbers in the database are in international format.',
        imported: 'Database imported',
        import_title: 'Select fields to import',
        field_title: {
          id: 'ID',
          created_at: 'Date of creation',
          updated_at: 'Update date',
          hlr_date: 'Hlr_date',
          hlr_state: 'Hlr_state',
          db_id: 'Database ID',
          number: 'Phone number',
          mcc: 'Mcc',
          mnc: 'Mnc',
          email: 'E-mail',
          name: 'Name',
          first_name: 'First Name',
          last_name: 'Last Name',
          age: 'Age',
          sex: 'Sex',
          male: 'Male',
          female: 'Female',
          Male: 'Male',
          Female: 'Female',
          country: 'Country',
          city: 'City',
          birthdate: 'Date of Birth',
          custom1: 'Custom field #1',
          custom2: 'Custom field #2',
          custom3: 'Custom field #3',
          custom4: 'Custom field #4',
          custom5: 'Custom field #5'
        }
      },

      export: {
        title: 'Export Database',
        content: 'Select fields to export',
        button: {
          download: 'Download'
        },
        success: 'Database export started. You will receive a notification with a download link.'
      }
    },
    successful_sort: 'Successful sort'
  },

  import: {
    tooltip: {
      header: 'One column must be a phone number at least'
    },
    create: {
      description:
        'Phone number is a required field for sending. Each field must have a unique name. You can assign field names to the actual data.',
      count: 'The database includes contacts: {count}',
      button: {
        upload_data: 'Upload data',
        ignore_header: 'Ignore header'
      }
    }
  },

  tooltips: {
    export_your_db: 'Export your database to a csv file'
  }
};
